// extracted by mini-css-extract-plugin
module.exports = {"Card":"CircleProgress_Card__1QsgD","Percent":"CircleProgress_Percent__1wCgO","Number":"CircleProgress_Number__kS7N0"};